(function () {
  'use strict';

  var Core = window.TMPPartsFinderCore;
  if (!Core || customElements.get('tmp-parts-finder')) return;

  var text = function (value) { return Core.clean(value, 300); };

  class TMPPartsFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = this.readConfig();
      this.form = this.querySelector('[data-tmp-form]');
      this.applicationSelect = this.querySelector('[data-tmp-application]');
      this.makeSelect = this.querySelector('[data-tmp-make]');
      this.modelSelect = this.querySelector('[data-tmp-model]');
      this.variantField = this.querySelector('[data-tmp-variant-field]');
      this.variantLabel = this.querySelector('[data-tmp-variant-label]');
      this.variantSelect = this.querySelector('[data-tmp-variant]');
      this.findButton = this.querySelector('[data-tmp-find]');
      this.matchRegion = this.querySelector('[data-tmp-match]');
      this.categoryRegion = this.querySelector('[data-tmp-categories]');
      this.productRegion = this.querySelector('[data-tmp-products]');
      this.savedRegion = this.querySelector('[data-tmp-saved-region]');
      this.savedSelect = this.querySelector('[data-tmp-saved-select]');
      this.savePanel = this.querySelector('[data-tmp-save-panel]');
      this.status = this.querySelector('[data-tmp-status]');
      this.alert = this.querySelector('[data-tmp-alert]');
      this.steps = Array.from(this.querySelectorAll('[data-tmp-step]'));
      this.state = { match: null, category: null, activeStep: 0, families: [], family: null };
      this.requests = { makes: 0, models: 0, categories: 0, products: 0 };
      this.productCache = new Map();
      this.enrichmentQueue = [];
      this.activeEnrichments = 0;
      this.customSelects = new Map();
      this.storage = Core.storageAdapter(window.localStorage, this.config.storageKey, this.config.maxProfiles);
      [this.applicationSelect, this.makeSelect, this.modelSelect, this.variantSelect, this.savedSelect].forEach((select) => this.enhanceSelect(select));
      this.bindEvents();
      this.resetDependentSelect(this.makeSelect, this.string('chooseApplicationFirst', 'Choose an application first'));
      this.resetDependentSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
      this.resetVariant();
      this.setStep(0);
      this.renderSaved(this.storage.read());
      if (this.config.customer && this.config.customer.signedIn) {
        this.loadAccountProfiles();
      }
      this.loadApplications().then(async (loaded) => {
        if (!loaded) return;
        var restoredHandoff = await this.restoreHeroHandoff();
        if (!restoredHandoff) await this.restorePendingSelection();
        if (this.config.customer && this.config.customer.signedIn) this.resumePendingSave();
      });
    }

    readConfig() {
      var script = this.querySelector('[data-tmp-config]');
      try {
        return JSON.parse(script ? script.textContent : '{}');
      } catch (error) {
        return { strings: {} };
      }
    }

    string(key, fallback) {
      return text(this.config.strings && this.config.strings[key]) || fallback;
    }

    enhanceSelect(select) {
      if (!select || this.customSelects.has(select)) return;
      if (!select.id) select.id = (this.id || 'TMPPartsFinder') + '-Select-' + (this.customSelects.size + 1);
      var label = this.querySelector('label[for="' + CSS.escape(select.id) + '"]') || select.closest('label');
      var wrapper = document.createElement('div');
      wrapper.className = 'tmp-parts-finder__custom-select';
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'tmp-parts-finder__select-trigger';
      trigger.id = select.id + '-Trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      var menu = document.createElement('ul');
      menu.className = 'tmp-parts-finder__select-menu';
      menu.id = select.id + '-Menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;
      trigger.setAttribute('aria-controls', menu.id);
      if (label) {
        label.id = label.id || select.id + '-Label';
        label.htmlFor = trigger.id;
        trigger.setAttribute('aria-labelledby', label.id + ' ' + trigger.id);
      }
      wrapper.append(trigger, menu);
      select.insertAdjacentElement('afterend', wrapper);
      select.classList.add('tmp-parts-finder__native-select');
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      this.customSelects.set(select, { wrapper: wrapper, trigger: trigger, menu: menu });

      var close = (restoreFocus) => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      };
      var focusOption = (direction) => {
        var options = Array.from(menu.querySelectorAll('[role="option"]'));
        if (!options.length) return;
        var active = document.activeElement;
        var index = options.indexOf(active);
        if (direction === 'first') index = 0;
        else if (direction === 'last') index = options.length - 1;
        else index = index < 0 ? 0 : (index + direction + options.length) % options.length;
        options[index].focus();
      };
      var open = () => {
        if (trigger.disabled) return;
        this.customSelects.forEach(function (other) {
          if (other.menu === menu) return;
          other.menu.hidden = true;
          other.trigger.setAttribute('aria-expanded', 'false');
        });
        var triggerBox = trigger.getBoundingClientRect();
        var roomBelow = Math.max(0, window.innerHeight - triggerBox.bottom - 16);
        var roomAbove = Math.max(0, triggerBox.top - 16);
        var openAbove = roomBelow < 220 && roomAbove > roomBelow;
        menu.dataset.placement = openAbove ? 'above' : 'below';
        menu.style.maxHeight = Math.max(160, Math.min(360, openAbove ? roomAbove : roomBelow)) + 'px';
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          var selected = menu.querySelector('[aria-selected="true"]');
          var target = selected || menu.querySelector('[role="option"]');
          target?.focus({ preventScroll: true });
          target?.scrollIntoView({ block: 'nearest' });
        });
      };
      var choose = (item) => {
        if (!item) return;
        select.value = item.dataset.value || '';
        this.syncCustomSelect(select);
        close(true);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };
      trigger.addEventListener('click', () => menu.hidden ? open() : close(false));
      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        open();
        window.requestAnimationFrame(() => focusOption(event.key === 'Home' ? 'first' : event.key === 'End' ? 'last' : event.key === 'ArrowUp' ? -1 : 1));
      });
      menu.addEventListener('click', (event) => choose(event.target.closest('[role="option"]')));
      menu.addEventListener('wheel', (event) => {
        if (menu.scrollHeight <= menu.clientHeight) return;
        event.preventDefault();
        menu.scrollTop += event.deltaY;
      }, { passive: false });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(event.target.closest('[role="option"]')); return; }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); focusOption(event.key === 'ArrowDown' ? 1 : -1); return; }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); focusOption(event.key === 'Home' ? 'first' : 'last'); }
      });
      wrapper.addEventListener('focusout', () => window.setTimeout(() => {
        if (!wrapper.contains(document.activeElement)) close(false);
      }, 0));
      select.addEventListener('change', () => this.syncCustomSelect(select));
      this.syncCustomSelect(select);
    }

    syncCustomSelect(select) {
      var custom = this.customSelects && this.customSelects.get(select);
      if (!custom) return;
      var selected = select.selectedOptions && select.selectedOptions[0];
      custom.trigger.textContent = selected ? selected.textContent : '';
      custom.trigger.disabled = select.disabled;
      custom.trigger.dataset.placeholder = !select.value ? 'true' : 'false';
      custom.menu.replaceChildren();
      Array.from(select.options).forEach(function (option) {
        var item = document.createElement('li');
        item.setAttribute('role', 'option');
        item.tabIndex = -1;
        item.dataset.value = option.value;
        item.setAttribute('aria-selected', option.value === select.value ? 'true' : 'false');
        item.textContent = option.textContent;
        custom.menu.append(item);
      });
      if (select.disabled) {
        custom.menu.hidden = true;
        custom.trigger.setAttribute('aria-expanded', 'false');
      }
    }

    bindEvents() {
      this.applicationSelect.addEventListener('change', () => this.onApplicationChange());
      this.makeSelect.addEventListener('change', () => this.onMakeChange());
      this.modelSelect.addEventListener('change', () => this.onModelChange());
      if (this.variantSelect) this.variantSelect.addEventListener('change', () => this.onVariantChange());
      this.querySelectorAll('.tmp-parts-finder__auth-panel form').forEach((form) => {
        form.addEventListener('submit', () => this.preservePendingNavigation());
      });
      this.findButton.addEventListener('click', () => this.findMatch());
      if (this.savedSelect) this.savedSelect.addEventListener('change', () => this.useSavedProfile());
      this.addEventListener('click', (event) => {
        var save = event.target.closest('[data-tmp-save]');
        var use = event.target.closest('[data-tmp-use-details]');
        var category = event.target.closest('[data-tmp-category]');
        var edit = event.target.closest('[data-tmp-edit]');
        var close = event.target.closest('[data-tmp-save-close]');
        var restart = event.target.closest('[data-tmp-restart]');
        var preserveNavigation = event.target.closest('[data-tmp-preserve-navigation]');
        if (save) this.saveMatch();
        if (use) this.useMatchDetails();
        if (category) this.selectCategory(category.dataset.tmpCategory);
        if (edit) this.editStep(Number(edit.dataset.tmpEdit || 0));
        if (close) this.closeSavePanel(true);
        if (restart) this.restartSelection();
        if (preserveNavigation) this.preservePendingNavigation();
      });
    }

    apiBase() {
      return Core.safeEndpoint(this.config.resolverApiBaseUrl, window.location.origin);
    }

    accountEndpoint() {
      var endpoint = Core.safeEndpoint(this.config.accountEndpoint, window.location.origin);
      if (!endpoint) return '';
      try {
        return new URL(endpoint).origin === window.location.origin ? endpoint : '';
      } catch (error) {
        return '';
      }
    }

    async fetchJSON(url, options) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
      try {
        var response = await fetch(url, Object.assign({
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller.signal
        }, options || {}));
        if (!response.ok) {
          var httpError = new Error('HTTP ' + response.status);
          httpError.status = response.status;
          throw httpError;
        }
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') === -1) {
          var formatError = new Error('Expected JSON response');
          formatError.status = response.status;
          formatError.code = 'NON_JSON';
          throw formatError;
        }
        return await response.json();
      } finally {
        window.clearTimeout(timeout);
      }
    }

    resetDependentSelect(select, label) {
      if (!select) return;
      select.replaceChildren(new Option(label, ''));
      select.disabled = true;
      this.syncCustomSelect(select);
    }

    resetVariant() {
      if (!this.variantSelect || !this.variantField) return;
      if (this.variantLabel) this.variantLabel.textContent = this.string('variantLabel', 'Model version (optional)');
      this.resetDependentSelect(this.variantSelect, this.string('chooseModelFirst', 'Choose a model first'));
      this.updateVariantPlaceholderState();
      this.variantField.hidden = true;
    }

    updateVariantPlaceholderState() {
      if (!this.variantSelect) return;
      this.variantSelect.dataset.placeholder = this.variantSelect.value ? 'false' : 'true';
      this.syncCustomSelect(this.variantSelect);
    }

    populateSelect(select, placeholder, rows, valueKey, labelKey, countKey) {
      select.replaceChildren(new Option(placeholder, ''));
      rows.forEach(function (row) {
        var value = text(row[valueKey]);
        var label = text(row[labelKey]) || value;
        var count = Number(row[countKey]);
        if (!value || !label) return;
        var option = new Option(Number.isFinite(count) && count > 0 ? label + ' (' + count + ')' : label, value);
        option.dataset.label = label;
        Object.keys(row).forEach(function (key) {
          var dataKey = key.replace(/_([a-z])/g, function (_, letter) { return letter.toUpperCase(); });
          if (row[key] != null && typeof row[key] !== 'object') option.dataset[dataKey] = String(row[key]);
        });
        if (Array.isArray(row.equipment_ids)) option.dataset.equipmentIds = JSON.stringify(row.equipment_ids);
        select.append(option);
      });
      select.disabled = select.options.length < 2;
      this.syncCustomSelect(select);
    }

    async loadApplications() {
      var base = this.apiBase();
      if (!base) {
        this.applicationSelect.disabled = false;
        this.syncCustomSelect(this.applicationSelect);
        this.setAlert(this.string('apiMissing', 'Add the resolver API URL in the section settings before testing live matches.'));
        return false;
      }
      try {
        var data = await this.fetchJSON(base + '/api/catalog/applications');
        var rows = Core.rowsFrom(data, ['applications', 'rows', 'results']).filter(function (row) {
          var key = text(row.application_key || row.key || row.label).toLowerCase();
          return key !== 'other' && key !== 'other equipment';
        });
        this.populateSelect(this.applicationSelect, this.string('applicationPlaceholder', 'Choose application'), rows, 'label', 'label', 'equipment_count');
        return true;
      } catch (error) {
        this.applicationSelect.disabled = false;
        this.syncCustomSelect(this.applicationSelect);
        this.setAlert(this.string('apiUnavailable', 'The application list could not be loaded. Try again shortly.'));
        return false;
      }
    }

    async onApplicationChange() {
      this.clearMatchAndResults();
      this.state.families = [];
      this.state.family = null;
      this.updateFindLabel();
      this.resetDependentSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
      this.resetVariant();
      var application = this.selectedLabel(this.applicationSelect);
      if (!application) {
        this.resetDependentSelect(this.makeSelect, this.string('chooseApplicationFirst', 'Choose an application first'));
        return;
      }
      var request = ++this.requests.makes;
      this.resetDependentSelect(this.makeSelect, this.string('loadingMakes', 'Loading makes…'));
      try {
        var url = this.apiBase() + '/api/catalog/manufacturers?application=' + encodeURIComponent(application);
        var data = await this.fetchJSON(url);
        if (request !== this.requests.makes) return;
        var rows = Core.rowsFrom(data, ['manufacturers', 'rows', 'results']);
        this.populateSelect(this.makeSelect, this.string('makePlaceholder', 'Choose make'), rows, 'manufacturer', 'manufacturer', 'equipment_count');
      } catch (error) {
        if (request !== this.requests.makes) return;
        this.resetDependentSelect(this.makeSelect, this.string('makeLoadError', 'Makes unavailable — try again'));
        this.setAlert(this.string('apiUnavailable', 'The finder data could not be loaded. Try again shortly.'));
      }
    }

    async onMakeChange() {
      this.clearMatchAndResults();
      this.state.families = [];
      this.state.family = null;
      this.resetVariant();
      var application = this.selectedLabel(this.applicationSelect);
      var make = this.selectedLabel(this.makeSelect);
      if (!application || !make) {
        this.resetDependentSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
        return;
      }
      var request = ++this.requests.models;
      this.resetDependentSelect(this.modelSelect, this.string('loadingModels', 'Loading models…'));
      try {
        var url = this.apiBase() + '/api/catalog/models?application=' + encodeURIComponent(application) + '&manufacturer=' + encodeURIComponent(make) + '&limit=2500';
        var data = await this.fetchJSON(url);
        if (request !== this.requests.models) return;
        var rows = Core.rowsFrom(data, ['models', 'rows', 'results']);
        this.state.families = Core.groupModels(rows, { application: application, manufacturer: make });
        this.modelSelect.replaceChildren(new Option(this.string('modelPlaceholder', 'Choose model'), ''));
        this.state.families.forEach((family) => {
          var option = new Option(family.label, family.key);
          option.dataset.label = family.label;
          this.modelSelect.append(option);
        });
        this.modelSelect.disabled = this.modelSelect.options.length < 2;
        this.syncCustomSelect(this.modelSelect);
        if (this.modelSelect.options.length < 2) {
          this.resetDependentSelect(this.modelSelect, this.string('noModels', 'No models available for this selection'));
        }
      } catch (error) {
        if (request !== this.requests.models) return;
        this.resetDependentSelect(this.modelSelect, this.string('modelLoadError', 'Models unavailable — try again'));
        this.setAlert(this.string('apiUnavailable', 'The finder data could not be loaded. Try again shortly.'));
      }
    }

    onModelChange() {
      this.clearMatchAndResults();
      this.state.family = this.state.families.find((family) => family.key === this.modelSelect.value) || null;
      this.resetVariant();
      if (this.state.family && this.state.family.hasVariants && (this.config.showModelVersion || this.state.family.requiresVariant) && this.variantSelect && this.variantField) {
        if (this.variantLabel) {
          this.variantLabel.textContent = this.state.family.requiresVariant
            ? this.string('requiredVariantLabel', 'Exact model / version')
            : this.string('variantLabel', 'Model version (optional)');
        }
        var placeholder = this.state.family.requiresVariant
          ? this.string('requiredVariantPlaceholder', 'Choose exact model / version (required)')
          : this.string('variantPlaceholder', 'All variants');
        this.variantSelect.replaceChildren(new Option(placeholder, ''));
        this.state.family.variants.forEach((variant) => {
          var option = new Option(variant.label, variant.key);
          option.dataset.label = variant.label;
          this.variantSelect.append(option);
        });
        this.variantSelect.disabled = false;
        this.variantField.hidden = false;
        this.updateVariantPlaceholderState();
      }
      this.findButton.disabled = !this.state.family || Boolean(this.state.family.requiresVariant);
    }

    onVariantChange() {
      this.clearMatchAndResults();
      this.updateVariantPlaceholderState();
      this.findButton.disabled = !this.state.family || Boolean(this.state.family.requiresVariant && !(this.variantSelect && this.variantSelect.value));
    }

    selectedLabel(select) {
      var option = select && select.selectedOptions && select.selectedOptions[0];
      return option ? text(option.dataset.label || option.textContent.replace(/\s+\(\d+\)$/, '')) : '';
    }

    updateFindLabel() {
      var words = Core.terminology(this.selectedLabel(this.applicationSelect), this.config.strings);
      this.findButton.textContent = words.find;
    }

    findMatch() {
      this.setAlert('');
      if (!this.applicationSelect.value || !this.makeSelect.value || !this.modelSelect.value) {
        this.setAlert(this.string('completeDetails', 'Choose an application, make and model first.'));
        var incomplete = [this.applicationSelect, this.makeSelect, this.modelSelect].find(function (select) { return !select.value; });
        if (incomplete) incomplete.focus();
        return;
      }
      var family = this.state.family || this.state.families.find((item) => item.key === this.modelSelect.value);
      if (!family) return;
      var canSelectVariant = this.config.showModelVersion || family.requiresVariant;
      var variant = canSelectVariant ? family.variants.find((item) => item.key === (this.variantSelect && this.variantSelect.value)) || null : null;
      if (family.requiresVariant && !variant) {
        this.setAlert(this.string('requiredVariantMessage', 'Choose the exact model / version before continuing.'));
        var customVariant = this.variantSelect && this.customSelects.get(this.variantSelect);
        if (customVariant) customVariant.trigger.focus({ preventScroll: true });
        else if (this.variantSelect) this.variantSelect.focus({ preventScroll: true });
        return;
      }
      var selected = variant || family;
      var applicationOption = this.applicationSelect.selectedOptions[0];
      var make = this.selectedLabel(this.makeSelect);
      this.state.match = Core.sanitizeProfile({
        application: this.selectedLabel(this.applicationSelect),
        applicationKey: applicationOption.dataset.applicationKey || applicationOption.value,
        make: make,
        model: selected.modelCode,
        modelFamily: family.modelCode,
        variant: variant ? variant.modelCode : '',
        isBroadMatch: Boolean(family.hasVariants && !variant),
        displayName: [make, selected.modelCode].filter(Boolean).join(' '),
        canonicalEquipmentId: selected.canonicalEquipmentId,
        equipmentIds: selected.equipmentIds,
        categoryEquipmentIds: selected.categoryEquipmentIds
      });
      this.renderMatch();
      this.setStatus(this.string('matchFound', 'This is the match. Check the details, then save it or continue to matching parts.'));
      this.emit('application-found', { canonicalEquipmentId: this.state.match.canonicalEquipmentId, equipmentType: this.state.match.equipmentType, broadMatch: this.state.match.isBroadMatch });
    }

    escapeRegex(value) {
      return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    renderMatch() {
      this.matchRegion.replaceChildren();
      if (!this.state.match) {
        this.matchRegion.hidden = true;
        return;
      }
      var words = Core.terminology(this.state.match.application, this.config.strings);
      var card = document.createElement('article');
      card.className = 'tmp-parts-finder__match-card';
      var copy = document.createElement('div');
      var eyebrow = document.createElement('p');
      eyebrow.className = 'tmp-parts-finder__eyebrow';
      eyebrow.textContent = this.string('matchEyebrow', 'This is the match');
      var title = document.createElement('h3');
      title.className = 'tmp-parts-finder__match-title';
      title.textContent = this.state.match.displayName;
      var meta = document.createElement('p');
      meta.textContent = this.state.match.application + ' · ' + words.noun;
      copy.append(eyebrow, title, meta);
      if (this.state.match.isBroadMatch) {
        var broad = document.createElement('p');
        broad.className = 'tmp-parts-finder__broad-note';
        broad.textContent = this.string('familyMatchNote', 'No variant selected. Results cover the whole model family; choose a variant above to narrow fitment.');
        copy.append(broad);
      }
      var actions = document.createElement('div');
      actions.className = 'tmp-parts-finder__match-actions';
      var save = document.createElement('button');
      save.type = 'button';
      save.className = 'tmp-parts-finder__button tmp-parts-finder__button--secondary';
      save.dataset.tmpSave = '';
      save.textContent = words.save;
      var use = document.createElement('button');
      use.type = 'button';
      use.className = 'tmp-parts-finder__button';
      use.dataset.tmpUseDetails = '';
      use.textContent = words.use;
      actions.append(save, use);
      card.append(copy, actions);
      this.matchRegion.append(card);
      this.matchRegion.hidden = false;
    }

    async useMatchDetails() {
      if (!this.state.match) return;
      this.setStep(1);
      await this.loadCategories();
    }

    async loadCategories() {
      var match = this.state.match;
      if (!match) return;
      var request = ++this.requests.categories;
      this.categoryRegion.replaceChildren(this.loadingMessage(this.string('loadingCategories', 'Loading matching part categories…')));
      try {
        var ids = match.categoryEquipmentIds && match.categoryEquipmentIds.length ? match.categoryEquipmentIds : [match.canonicalEquipmentId];
        var data = await this.fetchJSON(this.apiBase() + '/api/catalog/categories', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ equipment_ids: ids })
        });
        if (request !== this.requests.categories) return;
        var rows = Core.rowsFrom(data, ['categories', 'facets', 'rows', 'results']);
        this.renderCategories(rows);
      } catch (error) {
        if (request !== this.requests.categories) return;
        this.categoryRegion.replaceChildren(this.messageCard(this.string('categoryError', 'Matching categories could not be loaded. Try again shortly.'), true));
      }
    }

    renderCategories(rows) {
      this.categoryRegion.replaceChildren();
      if (!rows.length) {
        this.categoryRegion.append(this.messageCard(this.string('noCategories', 'No exact part categories are available for this application yet.'), false));
        return;
      }
      var grid = document.createElement('div');
      grid.className = 'tmp-parts-finder__category-grid';
      rows.slice().sort(function (left, right) {
        var leftKey = text(left.category_key || left.facet_key || left.key);
        var rightKey = text(right.category_key || right.facet_key || right.key);
        var leftService = /service.*kit|kit.*service/i.test(leftKey) ? 0 : 1;
        var rightService = /service.*kit|kit.*service/i.test(rightKey) ? 0 : 1;
        if (leftService !== rightService) return leftService - rightService;
        return text(left.label || left.category_label || leftKey).localeCompare(text(right.label || right.category_label || rightKey), undefined, { numeric: true, sensitivity: 'base' });
      }).forEach((row) => {
        var key = text(row.category_key || row.facet_key || row.key);
        if (!key) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tmp-parts-finder__category-card';
        if (/service.*kit|kit.*service/i.test(key)) button.classList.add('tmp-parts-finder__category-card--service-kits');
        button.dataset.tmpCategory = key;
        button.dataset.label = text(row.label || row.category_label || key.replace(/_/g, ' '));
        var label = document.createElement('span');
        label.className = 'tmp-parts-finder__category-label';
        label.textContent = button.dataset.label;
        var count = document.createElement('span');
        count.className = 'tmp-parts-finder__count';
        var total = Number(row.sku_count != null ? row.sku_count : row.product_count != null ? row.product_count : row.rule_count);
        count.textContent = Number.isFinite(total) ? total + (total === 1 ? ' product' : ' products') : this.string('viewProducts', 'View products');
        button.append(label, count);
        grid.append(button);
      });
      this.categoryRegion.append(grid);
      this.setStatus(this.string('categoriesReady', 'Choose a category to see the exact matching products.'));
    }

    async selectCategory(key) {
      var button = this.querySelector('[data-tmp-category="' + CSS.escape(key) + '"]');
      this.state.category = { key: key, label: button ? text(button.dataset.label) : key.replace(/_/g, ' ') };
      this.setStep(2);
      await this.loadProducts();
    }

    async loadProducts() {
      var match = this.state.match;
      var category = this.state.category;
      if (!match || !category) return;
      var request = ++this.requests.products;
      this.productRegion.replaceChildren(this.loadingMessage(this.string('loadingProducts', 'Loading exact matching products…')));
      try {
        var data = await this.fetchJSON(this.apiBase() + '/api/resolve', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            canonical_equipment_id: match.canonicalEquipmentId,
            equipment_id: match.canonicalEquipmentId,
            equipment_ids: match.equipmentIds,
            manufacturer: match.make,
            model_code: match.model,
            application: match.application,
            category_key: category.key,
            category: category.key,
            scope: 'all',
            limit: Number(this.config.productLimit) || 24
          })
        });
        if (request !== this.requests.products) return;
        var rows = Core.rowsFrom(data, ['results', 'products', 'rows']);
        this.renderProducts(rows);
      } catch (error) {
        if (request !== this.requests.products) return;
        this.productRegion.replaceChildren(this.messageCard(this.string('productError', 'Exact products could not be loaded. Try again shortly.'), true));
      }
    }

    renderProducts(rows) {
      this.productRegion.replaceChildren();
      var seen = new Set();
      var allowed = rows.filter(function (row) {
        if (text(row.status).toLowerCase() === 'does_not_fit') return false;
        var key = text(row.sku || row.product_handle || row.product_url || row.shopify_product_title || row.product_title).toLowerCase();
        if (key && seen.has(key)) return false;
        if (key) seen.add(key);
        return true;
      });
      var heading = document.createElement('div');
      heading.className = 'tmp-parts-finder__result-heading';
      var headingCopy = document.createElement('div');
      var title = document.createElement('h3');
      title.textContent = this.state.category.label + ' for ' + this.state.match.displayName;
      headingCopy.append(title);
      if (this.state.match.isBroadMatch) {
        var broad = document.createElement('p');
        broad.className = 'tmp-parts-finder__broad-note';
        broad.textContent = this.string('familyProductsNote', 'These products are listed across this model family. Confirm the exact variant and any fitment note before ordering.');
        headingCopy.append(broad);
      }
      var count = document.createElement('p');
      count.dataset.tmpProductCount = '';
      count.textContent = allowed.length + (allowed.length === 1 ? ' matching product' : ' matching products');
      heading.append(headingCopy, count);
      this.productRegion.append(heading);
      if (!allowed.length) {
        this.productRegion.append(this.messageCard(this.string('noProducts', 'No exact products are published for this selection yet. Please contact TMP Global with the application details.'), false));
        this.appendRestartButton();
        return;
      }
      this.initialEnrichmentCount = 0;
      if (this.state.match.isBroadMatch) this.renderProductGroups(allowed);
      else this.renderProductGrid(allowed, this.productRegion);
      this.appendRestartButton();
      this.setStatus(this.state.match.isBroadMatch ? this.string('familyProductsNote', 'These products are listed across this model family. Confirm the exact variant and any fitment note before ordering.') : this.string('productsReady', 'Exact matching products are ready. Check any serial or range note before ordering.'));
      this.emit('products-loaded', { count: allowed.length, canonicalEquipmentId: this.state.match.canonicalEquipmentId, categoryKey: this.state.category.key });
    }

    productGroupLabel(row) {
      var family = text(this.state.match && this.state.match.modelFamily || this.state.match && this.state.match.model);
      var models = Array.isArray(row.matched_model_codes) ? row.matched_model_codes.map(text).filter(Boolean) : [];
      var variants = Array.from(new Set(models.filter(function (model) {
        return model.toLowerCase() !== family.toLowerCase();
      }))).sort(function (left, right) {
        return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' });
      });
      if (!variants.length) return family + ' family';
      return variants.join(', ');
    }

    renderProductGroups(rows) {
      var groups = new Map();
      rows.forEach((row) => {
        var label = this.productGroupLabel(row);
        if (!groups.has(label)) groups.set(label, []);
        groups.get(label).push(row);
      });
      var container = document.createElement('div');
      container.className = 'tmp-parts-finder__product-groups';
      Array.from(groups.entries()).sort(function (left, right) {
        return left[0].localeCompare(right[0], undefined, { numeric: true, sensitivity: 'base' });
      }).forEach(([label, products]) => {
        var group = document.createElement('section');
        group.className = 'tmp-parts-finder__product-group';
        var heading = document.createElement('h4');
        heading.textContent = label;
        var meta = document.createElement('p');
        meta.textContent = products.length + (products.length === 1 ? ' product' : ' products');
        var copy = document.createElement('div');
        copy.className = 'tmp-parts-finder__product-group-heading';
        copy.append(heading, meta);
        group.append(copy);
        this.renderProductGrid(products, group, true);
        container.append(group);
      });
      this.productRegion.append(container);
    }

    renderProductGrid(rows, parent, grouped) {
      var grid = document.createElement('div');
      grid.className = 'tmp-parts-finder__product-grid';
      if (grouped) grid.classList.add('tmp-parts-finder__product-grid--grouped');
      rows.forEach((row) => {
        var card = this.productCard(row);
        grid.append(card);
        if (card.dataset.state === 'ready') return;
        if (this.initialEnrichmentCount < 6) {
          this.initialEnrichmentCount += 1;
          this.enqueueProductEnrichment(card, row);
        } else this.observeProductCard(card, row);
      });
      parent.append(grid);
    }

    productCard(row) {
      var card = document.createElement('a');
      card.className = 'tmp-parts-finder__product-card';
      card.setAttribute('aria-disabled', 'true');
      card.dataset.state = 'loading';
      var media = document.createElement('div');
      media.className = 'tmp-parts-finder__product-media';
      media.dataset.state = 'loading';
      media.setAttribute('aria-hidden', 'true');
      var body = document.createElement('div');
      var vendor = document.createElement('p');
      vendor.className = 'tmp-parts-finder__vendor';
      vendor.textContent = text(row.shopify_vendor || row.vendor || row.brand);
      var title = document.createElement('h4');
      title.textContent = text(row.shopify_product_title || row.product_title || row.title || row.sku) || this.string('productFallback', 'Matching product');
      var sku = document.createElement('p');
      sku.className = 'tmp-parts-finder__sku';
      sku.textContent = row.sku ? 'SKU: ' + text(row.sku) : '';
      var fitment = document.createElement('p');
      fitment.className = 'tmp-parts-finder__fitment';
      fitment.textContent = this.fitmentLabel(row);
      var link = document.createElement('span');
      link.className = 'tmp-parts-finder__product-link';
      link.textContent = this.string('findingProduct', 'Finding product…');
      body.append(vendor, title, sku, fitment, link);
      card.append(media, body);
      if (text(row.shopify_catalog_source) === 'tmp_store' && row.product_handle) {
        var directHandle = text(row.product_handle).replace(/[^a-z0-9-]/gi, '');
        if (directHandle) {
          card.href = this.shopRoot() + 'products/' + encodeURIComponent(directHandle);
          card.dataset.state = 'ready';
          card.removeAttribute('aria-disabled');
          link.textContent = this.string('viewProduct', 'View product');
          this.setProductImage(media, row.product_image_url || '', title.textContent);
          if (!media.querySelector('img')) media.dataset.state = 'unavailable';
        }
      }
      return card;
    }

    setProductImage(media, value, alt) {
      if (!media || media.querySelector('img')) return;
      try {
        var url = new URL(value, window.location.origin);
        if (url.protocol !== 'https:' && url.origin !== window.location.origin) return;
        var image = document.createElement('img');
        image.src = url.href;
        image.alt = text(alt);
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 96;
        image.height = 96;
        media.append(image);
        media.dataset.state = 'ready';
      } catch (error) {}
    }

    observeProductCard(card, row) {
      this.productRows = this.productRows || new WeakMap();
      this.productRows.set(card, row);
      if (!('IntersectionObserver' in window)) {
        this.enqueueProductEnrichment(card, row);
        return;
      }
      if (!this.productObserver) {
        this.productObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.productObserver.unobserve(entry.target);
            this.enqueueProductEnrichment(entry.target, this.productRows.get(entry.target));
          });
        }, { rootMargin: '180px 0px' });
      }
      this.productObserver.observe(card);
    }

    enqueueProductEnrichment(card, row) {
      if (!card || !row || card.dataset.tmpEnrichmentQueued === 'true') return;
      card.dataset.tmpEnrichmentQueued = 'true';
      this.enrichmentQueue.push({ card: card, row: row });
      this.drainEnrichmentQueue();
    }

    drainEnrichmentQueue() {
      while (this.activeEnrichments < 3 && this.enrichmentQueue.length) {
        var task = this.enrichmentQueue.shift();
        this.activeEnrichments += 1;
        this.enrichProductCard(task.card, task.row).catch(function () {}).finally(() => {
          this.activeEnrichments -= 1;
          this.drainEnrichmentQueue();
        });
      }
    }

    async enrichProductCard(card, row) {
      var handle = text(row.product_handle || row.handle).replace(/[^a-z0-9-]/gi, '');
      var sku = text(row.sku);
      var product = sku ? await this.findStoreProductBySku(sku) : null;
      if (!product && handle) product = await this.fetchStoreProduct(handle);
      if (!card.isConnected) return;
      if (!product) {
        this.markProductUnavailable(card);
        return;
      }
      var media = card.querySelector('.tmp-parts-finder__product-media');
      var image = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image && (product.featured_image.url || product.featured_image.src);
      if (!image && Array.isArray(product.images) && product.images.length) image = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].url || product.images[0].src;
      if (!image && product.handle) {
        var detail = await this.fetchStoreProduct(product.handle);
        if (!card.isConnected) return;
        if (detail) {
          product = Object.assign({}, product, detail);
          image = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image && (product.featured_image.url || product.featured_image.src);
          if (!image && Array.isArray(product.images) && product.images.length) image = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].url || product.images[0].src;
        }
      }
      var productTitle = text(product.title || row.shopify_product_title || row.product_title || row.title || row.sku);
      this.setProductImage(media, image || '', productTitle);
      if (!media || !media.querySelector('img')) {
        if (media) media.dataset.state = 'unavailable';
      }
      var title = card.querySelector('h4');
      var vendor = card.querySelector('.tmp-parts-finder__vendor');
      var link = card.querySelector('.tmp-parts-finder__product-link');
      if (title && product.title) title.textContent = text(product.title);
      if (vendor && product.vendor) vendor.textContent = text(product.vendor);
      if (link && product.handle) {
        card.href = this.shopRoot() + 'products/' + encodeURIComponent(product.handle);
        card.dataset.state = 'ready';
        card.removeAttribute('aria-disabled');
        link.textContent = this.string('viewProduct', 'View product');
      } else {
        this.markProductUnavailable(card);
      }
    }

    markProductUnavailable(card) {
      if (!card) return;
      card.dataset.state = 'unavailable';
      card.removeAttribute('href');
      card.setAttribute('aria-disabled', 'true');
      var media = card.querySelector('.tmp-parts-finder__product-media');
      var link = card.querySelector('.tmp-parts-finder__product-link');
      if (media) media.dataset.state = 'unavailable';
      if (link) link.textContent = this.string('productUnavailable', 'Product details are temporarily unavailable');
    }

    shopRoot() {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      return typeof root === 'string' && root.charAt(0) === '/' ? root : '/';
    }

    fetchStoreProduct(handle) {
      var key = 'handle:' + handle.toLowerCase();
      if (!this.productCache.has(key)) {
        this.productCache.set(key, this.fetchStoreJSON(this.shopRoot() + 'products/' + encodeURIComponent(handle) + '.js').catch(function () { return null; }));
      }
      return this.productCache.get(key);
    }

    async fetchStoreJSON(url) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
      try {
        var response = await fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json, text/javascript' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return await response.json();
      } finally {
        window.clearTimeout(timeout);
      }
    }

    async findStoreProductBySku(sku) {
      var key = 'sku:' + sku.toLowerCase();
      if (this.productCache.has(key)) return this.productCache.get(key);
      var promise = (async () => {
        var url = this.shopRoot() + 'search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=5&resources[options][fields]=variants.sku';
        var data = await this.fetchJSON(url).catch(function () { return null; });
        var products = data && data.resources && data.resources.results && data.resources.results.products;
        if (!Array.isArray(products) || !products.length) return null;
        var target = sku.toLowerCase().replace(/[^a-z0-9]/g, '');
        var ordered = products.slice().sort(function (left, right) {
          var leftExact = text(left.handle).toLowerCase().replace(/[^a-z0-9]/g, '') === target ? 1 : 0;
          var rightExact = text(right.handle).toLowerCase().replace(/[^a-z0-9]/g, '') === target ? 1 : 0;
          return rightExact - leftExact;
        });
        for (var i = 0; i < ordered.length; i += 1) {
          var candidate = ordered[i];
          var candidateHandle = text(candidate.handle).replace(/[^a-z0-9-]/gi, '');
          if (!candidateHandle) {
            var pathMatch = text(candidate.url).match(/\/products\/([^/?#]+)/i);
            candidateHandle = pathMatch ? text(pathMatch[1]).replace(/[^a-z0-9-]/gi, '') : '';
          }
          if (!candidateHandle) continue;
          var detail = await this.fetchStoreProduct(candidateHandle);
          var variants = detail && Array.isArray(detail.variants) ? detail.variants : [];
          var exactSku = variants.some(function (variant) {
            return text(variant && variant.sku).toLowerCase().replace(/[^a-z0-9]/g, '') === target;
          });
          if (detail && exactSku) return detail;
        }
        return null;
      })().catch(function () { return null; });
      this.productCache.set(key, promise);
      return promise;
    }

    fitmentLabel(row) {
      if (row.needs_serial_review === 'yes' || row.serial_start || row.serial_end) return this.string('checkRange', 'Check serial or production range before ordering.');
      if (text(row.status).toLowerCase() === 'confirmed') return this.string('confirmedMatch', 'Listed for this application in the fitment data.');
      return this.string('verifyFitment', 'Verify the application details before ordering.');
    }

    saveMatch() {
      if (!this.state.match) return;
      if (this.config.customer && this.config.customer.signedIn) {
        this.persistAccountProfile(this.state.match);
        return;
      }
      if (!this.savePanel) return;
      var pending = {
        profile: this.state.match,
        createdAt: Date.now(),
        returnPath: window.location.pathname,
        scrollY: Math.max(0, Math.round(window.scrollY || 0))
      };
      try {
        window.localStorage.setItem(this.config.pendingStorageKey, JSON.stringify(pending));
      } catch (error) {
        this.setAlert(this.string('storageError', 'This browser could not preserve the pending save.'));
        return;
      }
      this.savePanel.hidden = false;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.savePanel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      var firstInput = this.savePanel.querySelector('input');
      if (firstInput) window.requestAnimationFrame(function () { firstInput.focus(); });
    }

    readPendingSave() {
      var pending;
      try { pending = JSON.parse(window.localStorage.getItem(this.config.pendingStorageKey) || 'null'); } catch (error) { pending = null; }
      if (!pending || !Core.validProfile(pending.profile)) return null;
      if (Date.now() - Number(pending.createdAt || 0) > 24 * 60 * 60 * 1000) {
        try { window.localStorage.removeItem(this.config.pendingStorageKey); } catch (error) {}
        return null;
      }
      return pending;
    }

    preservePendingNavigation() {
      var pending = this.readPendingSave();
      if (!pending && this.state.match) pending = { profile: this.state.match, createdAt: Date.now() };
      if (!pending) return;
      pending.returnPath = window.location.pathname;
      pending.scrollY = Math.max(0, Math.round(window.scrollY || 0));
      try { window.localStorage.setItem(this.config.pendingStorageKey, JSON.stringify(pending)); } catch (error) {}
    }

    heroHandoffKey() {
      return text(this.config.handoffStorageKey) || 'tmp-parts-finder.hero-handoff';
    }

    readHeroHandoff() {
      var key = this.heroHandoffKey();
      var raw = '';
      try { raw = window.sessionStorage.getItem(key) || ''; } catch (error) {}
      if (!raw) {
        try { raw = window.localStorage.getItem(key) || ''; } catch (error) {}
      }
      if (!raw) return null;
      var handoff;
      try { handoff = JSON.parse(raw); } catch (error) { handoff = null; }
      var valid = handoff
        && handoff.action === 'use-details'
        && Core.validProfile(handoff.profile)
        && Date.now() - Number(handoff.createdAt || 0) <= 15 * 60 * 1000
        && (!handoff.returnPath || handoff.returnPath === window.location.pathname);
      if (!valid) {
        this.clearHeroHandoff();
        return null;
      }
      return handoff;
    }

    clearHeroHandoff() {
      var key = this.heroHandoffKey();
      try { window.sessionStorage.removeItem(key); } catch (error) {}
      try { window.localStorage.removeItem(key); } catch (error) {}
    }

    async restoreProfileSelection(profile) {
      profile = Core.sanitizeProfile(profile);
      if (!Core.validProfile(profile)) return false;
      if (!this.setSelectByLabel(this.applicationSelect, profile.application)) return false;
      await this.onApplicationChange();
      if (!this.setSelectByLabel(this.makeSelect, profile.make)) return false;
      await this.onMakeChange();
      if (!this.setSelectByLabel(this.modelSelect, profile.modelFamily || profile.model)) return false;
      this.onModelChange();
      if (profile.variant && this.variantSelect && !this.setSelectByLabel(this.variantSelect, profile.variant)) return false;
      this.onVariantChange();
      this.findMatch();
      return Boolean(this.state.match);
    }

    async restoreHeroHandoff() {
      var handoff = this.readHeroHandoff();
      if (!handoff) return false;
      var restored = await this.restoreProfileSelection(handoff.profile);
      this.clearHeroHandoff();
      if (!restored) {
        this.setAlert(this.string('handoffError', 'We could not restore that application. Please choose it again.'));
        return false;
      }
      await this.useMatchDetails();
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('tmp_finder');
        window.history.replaceState({}, '', url.pathname + url.search + '#tmp-parts-finder');
      } catch (error) {}
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.requestAnimationFrame(() => this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }));
      return true;
    }

    async restorePendingSelection() {
      var pending = this.readPendingSave();
      if (!pending || pending.returnPath && pending.returnPath !== window.location.pathname) return false;
      var restored = await this.restoreProfileSelection(pending.profile);
      if (!restored) return false;
      var y = Number(pending.scrollY);
      if (Number.isFinite(y)) {
        window.requestAnimationFrame(function () { window.scrollTo({ top: Math.max(0, y), behavior: 'auto' }); });
      }
      return true;
    }

    closeSavePanel(restoreFocus) {
      if (this.savePanel) this.savePanel.hidden = true;
      if (restoreFocus) {
        var trigger = this.matchRegion && this.matchRegion.querySelector('[data-tmp-save]');
        if (trigger) window.requestAnimationFrame(function () { trigger.focus(); });
      }
    }

    async persistAccountProfile(profile) {
      var endpoint = this.accountEndpoint();
      if (!endpoint) {
        this.setAlert(this.string('accountEndpointMissing', 'Account saving is not connected yet. Add the authenticated account endpoint in the section settings.'));
        return;
      }
      this.setStatus(this.string('savingAccount', 'Saving to your TMP Global account…'));
      try {
        var data = await this.fetchJSON(endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'upsert', profile: Core.sanitizeProfile(profile) })
        });
        if (data && data.ok === false) throw new Error('Save rejected');
        var savedProfile = Core.sanitizeProfile(data && data.profile || profile);
        this.storage.save(savedProfile);
        this.renderSaved(this.storage.read());
        this.closeSavePanel();
        var words = Core.terminology(savedProfile.application, this.config.strings);
        this.setStatus(words.saved);
        try { window.localStorage.removeItem(this.config.pendingStorageKey); } catch (error) {}
        this.emit('application-saved', { canonicalEquipmentId: savedProfile.canonicalEquipmentId, equipmentType: savedProfile.equipmentType });
      } catch (error) {
        var missing = error && (error.status === 404 || error.code === 'NON_JSON');
        this.setAlert(missing
          ? this.string('accountEndpointMissing', 'Your account is signed in, but account equipment saving is not connected yet.')
          : this.string('accountSaveError', 'We could not save this to your account. Please try again or contact TMP Global.'));
      }
    }

    async loadAccountProfiles() {
      var endpoint = this.accountEndpoint();
      if (!endpoint) return;
      try {
        var data = await this.fetchJSON(endpoint + (endpoint.indexOf('?') === -1 ? '?action=list' : '&action=list'));
        var profiles = Core.rowsFrom(data, ['profiles', 'applications', 'rows']);
        if (profiles.length) {
          this.storage.replace(profiles);
          this.renderSaved(this.storage.read());
        }
      } catch (error) {}
    }

    resumePendingSave() {
      var pending = this.readPendingSave();
      if (!pending) return;
      this.persistAccountProfile(pending.profile);
    }

    renderSaved(profiles) {
      if (!this.savedSelect || !this.savedRegion) return;
      this.savedSelect.replaceChildren(new Option(this.string('savedPlaceholder', 'Choose a saved application'), ''));
      profiles.forEach(function (profile) {
        var option = new Option(profile.name || profile.displayName, profile.id);
        option.dataset.profile = JSON.stringify(profile);
        this.savedSelect.append(option);
      }, this);
      this.savedRegion.hidden = profiles.length === 0;
      this.syncCustomSelect(this.savedSelect);
    }

    useSavedProfile() {
      var option = this.savedSelect.selectedOptions[0];
      if (!option || !option.dataset.profile) return;
      var profile;
      try { profile = Core.sanitizeProfile(JSON.parse(option.dataset.profile)); } catch (error) { return; }
      this.state.match = profile;
      this.setSelectByLabel(this.applicationSelect, profile.application);
      this.renderMatch();
      this.setStatus(this.string('savedSelected', 'Saved application selected.'));
    }

    setSelectByLabel(select, label) {
      if (!select) return false;
      var target = text(label).toLowerCase();
      var option = Array.from(select.options).find(function (item) {
        return text(item.dataset.label || item.textContent).toLowerCase() === target;
      });
      if (!option) return false;
      select.value = option.value;
      this.syncCustomSelect(select);
      return true;
    }

    setStep(index) {
      this.state.activeStep = index;
      this.steps.forEach(function (step, position) {
        step.dataset.state = position === index ? 'active' : position < index ? 'complete' : 'pending';
        var body = step.querySelector('[data-tmp-step-body]');
        if (body) body.hidden = position !== index;
      });
      if (index > 0) this.renderSummary(0, this.state.match ? this.state.match.displayName : '');
      if (index > 1) this.renderSummary(1, this.state.category ? this.state.category.label : '');
    }

    renderSummary(index, value) {
      var step = this.steps[index];
      var region = step && step.querySelector('[data-tmp-summary]');
      if (!region) return;
      region.replaceChildren();
      var label = document.createElement('span');
      label.textContent = value;
      var edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'tmp-parts-finder__text-button';
      edit.dataset.tmpEdit = String(index);
      edit.textContent = this.string('edit', 'Edit');
      region.append(label, edit);
    }

    editStep(index) {
      if (index === 0) {
        this.state.category = null;
        this.categoryRegion.replaceChildren();
        this.productRegion.replaceChildren();
      }
      if (index === 1) {
        this.state.category = null;
        this.productRegion.replaceChildren();
      }
      this.setStep(index);
    }

    appendRestartButton() {
      var footer = document.createElement('div');
      footer.className = 'tmp-parts-finder__result-footer';
      var restart = document.createElement('button');
      restart.type = 'button';
      restart.className = 'tmp-parts-finder__text-button tmp-parts-finder__restart';
      restart.dataset.tmpRestart = '';
      restart.textContent = this.string('restartSelection', 'Start fresh');
      footer.append(restart);
      this.productRegion.append(footer);
    }

    restartSelection() {
      this.requests.makes += 1;
      this.requests.models += 1;
      this.applicationSelect.value = '';
      this.syncCustomSelect(this.applicationSelect);
      this.resetDependentSelect(this.makeSelect, this.string('chooseApplicationFirst', 'Choose an application first'));
      this.resetDependentSelect(this.modelSelect, this.string('chooseMakeFirst', 'Choose a make first'));
      this.resetVariant();
      this.state.families = [];
      this.state.family = null;
      this.clearMatchAndResults();
      this.updateFindLabel();
      this.setStatus('');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      window.requestAnimationFrame(() => this.applicationSelect.focus());
    }

    clearMatchAndResults() {
      this.state.match = null;
      this.state.category = null;
      this.matchRegion.replaceChildren();
      this.matchRegion.hidden = true;
      this.categoryRegion.replaceChildren();
      this.productRegion.replaceChildren();
      this.setStep(0);
      this.steps.forEach(function (step) {
        var summary = step.querySelector('[data-tmp-summary]');
        if (summary) summary.replaceChildren();
      });
      this.findButton.disabled = true;
      this.closeSavePanel();
      this.setAlert('');
      this.setStatus('');
    }

    loadingMessage(message) {
      var card = this.messageCard(message, false);
      card.setAttribute('aria-busy', 'true');
      return card;
    }

    messageCard(message, error) {
      var card = document.createElement('p');
      card.className = 'tmp-parts-finder__message' + (error ? ' tmp-parts-finder__message--error' : '');
      card.textContent = message;
      return card;
    }

    setStatus(message) {
      if (this.status) this.status.textContent = text(message);
      if (message) this.setAlert('');
    }

    setAlert(message) {
      if (this.alert) this.alert.textContent = text(message);
    }

    emit(name, detail) {
      this.dispatchEvent(new CustomEvent('tmp-parts-finder:' + name, { bubbles: true, detail: detail || {} }));
    }
  }

  customElements.define('tmp-parts-finder', TMPPartsFinder);
})();